/* eslint-disable react/react-in-jsx-scope */
import { useMemo } from 'react';

import { ErrorBoundary } from '@lululemon/mwa-logger';
import { useABFlag } from '@lululemon/mwa-ab-testing';
import getFusionExperimentGraphqlArgByLocale from '@lululemon/ecom-common/src/util/getFusionExperimentGraphqlArgByLocale';

import Categories from '../../components/categories/categories';
import GoesWellWithCarousel from '../../components/goes-well-with-carousel/goes-well-with-carousel.adapter';
import OutfitsInspirationWrapper from '../../components/outfits-inspiration/outfits-inspiration-wrapper';
import ProductEducationFactory from '../../components/product-education-factory';
import RecentlyViewedCarousel from '../../components/recently-viewed-carousel/recently-viewed-carousel.adapter';
import YouMayAlsoLikeCarousel from '../../components/you-may-also-like-carousel/you-may-also-like-carousel';
import PdpReviews from '../../components/reviews/pdp-reviews/index';
import { useProductTier } from '../../hooks/use-product-attributes';
import PDPBrandStatement from '../../components/pdp-brand-statement/pdp-brand-statement';
import { useIsPopularCategoriesEnabled } from '../../hooks/useCategories';
import { PDPFeaturedCategory } from '../../components/pdp-featured-categories/pdp-featured-categories';
import { featuredCategoryTitle } from '../../constants/featuredCategoryConstants';
import {
  useIsGoesWellWithEnabled,
  useIsReviewsEnabled,
} from '../../hooks/use-features-enablement';
import YouMayAlsoLikeGrid from '../../components/recommenders-grid/recommenders-grid';

export function PdpBelowTheFold({
  flags,
  isSeoPdpFeaturedCategoriesEnabled,
  nextLocale,
  relatedUrls,
}) {
  const tier = useProductTier();
  const popularCategoriesFlagSet = useIsPopularCategoriesEnabled();
  const isGoesWellWithEnabled = useIsGoesWellWithEnabled();
  const isExpansiveYmalEnabled = useABFlag('pdpExpansiveYMAL', false);
  const reviewsAreEnabledForLocale = useIsReviewsEnabled();

  const {
    fusionExperimentGraphqlArgByLocale:
      fusionExperimentGraphqlArgByLocaleLDFlag,
    recsEnablePcmByLocale: recsEnablePcmByLocaleLDFlag,
  } = flags;
  const [fusionExperimentVariant, isFusionExperimentEnabled] = useMemo(() => {
    return getFusionExperimentGraphqlArgByLocale(
      fusionExperimentGraphqlArgByLocaleLDFlag,
      recsEnablePcmByLocaleLDFlag,
      nextLocale
    );
  }, [
    fusionExperimentGraphqlArgByLocaleLDFlag,
    recsEnablePcmByLocaleLDFlag,
    nextLocale,
  ]);

  return (
    <>
      {tier === '1' && <ProductEducationFactory />}
      <ErrorBoundary
        fallback={() => null}
        remote="pdp"
        componentName="OutfitsInspirationComponent"
      >
        <OutfitsInspirationWrapper />
      </ErrorBoundary>
      {isExpansiveYmalEnabled ? (
        <YouMayAlsoLikeGrid />
      ) : (
        <YouMayAlsoLikeCarousel
          fusionExperimentVariant={
            isFusionExperimentEnabled ? fusionExperimentVariant : undefined
          }
        />
      )}
      {isGoesWellWithEnabled && (
        <GoesWellWithCarousel
          fusionExperimentVariant={
            isFusionExperimentEnabled ? fusionExperimentVariant : undefined
          }
        />
      )}
      <RecentlyViewedCarousel />
      {popularCategoriesFlagSet && <Categories />}
      {reviewsAreEnabledForLocale && <PdpReviews />}
      <PDPBrandStatement />
      {isSeoPdpFeaturedCategoriesEnabled && (
        <div className="wrapper container-fluid">
          <PDPFeaturedCategory
            categoryTitle={featuredCategoryTitle}
            featuredCategories={relatedUrls}
          />
        </div>
      )}
    </>
  );
}
